
import { defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheTextarea from '@/common/components/UI/TheTextarea/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Modal,
        TheTextarea,
        Checkbox,
        TheButton,
    },
    emits: ['submit', 'cancel'],
    setup(_, { emit }) {
        const state = reactive({
            comment: null as string | null,
            is_confirmed: false,
        })

        const state_form$ = useVuelidate({ comment: { required } }, state)

        const emitSubmit = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submit', { ...state })
        }

        const emitCancel = () => {
            emit('cancel')
        }

        return {
            state,
            state_form$,
            //
            emitSubmit,
            emitCancel,
        }
    },
})
